// Copyright © 2021 Move Closer
/**
 * @author Łukasz Sitnicki <lukasz.sitnicki@movecloser.pl>
 */
export var SortDirectionMap;
(function (SortDirectionMap) {
    SortDirectionMap["Asc"] = "asc";
    SortDirectionMap["Desc"] = "desc";
})(SortDirectionMap || (SortDirectionMap = {}));
